'use client';
import styles from './style.module.scss';
import {useEffect, useMemo, useState} from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import MyProfileImg from '@/components/my/common/item/MyProfileImg';
import {handleLogin, handleUserInfo, loginState} from '@/utils/event/util';
import GiftSubEventApi from '@/api/events/giftsub-event';
import globalDomains from '@/utils/global-domains';

const GiftSubEvent = ({onBodyId}) => {
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalText, setModalText] = useState('');
  /** 로그인 한 사용자의 상태 */
  const {userId, userNickname} = useMemo(() => handleUserInfo(), []);

  useEffect(() => {
    /**
     * 초기 로드시 body id 셋팅
     */
    onBodyId && onBodyId(styles.body);
    setLoading(true);
  }, [onBodyId]);

  useEffect(() => {
    AOS.init();
  }, []);
  const checkEventUser = async () => {
    const {msg} = await GiftSubEventApi.checkEventUser();
    setModalText(msg);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    loading && (
      <>
        <div data-aos-easing='ease' data-aos-duration='400' data-aos-delay='0'>
          <div id='wrap' className={styles.wrap}>
            <header className={styles.header}>
              <div className={styles.inner}>
                <h1 className={styles.logo}>
                  <a
                    href='https://www.sooplive.co.kr/'
                    target='_blank'
                    className={styles.link}
                    rel='noopener noreferrer'>
                    SOOP
                  </a>
                </h1>
                <div className={styles.login_wrap}>
                  {loginState ? (
                    <>
                      <div className={styles.nick_wrap}>
                        <span className={styles.thumb}>
                          <MyProfileImg
                            userId={userId}
                            className={styles.img}
                          />
                        </span>
                        <span className={styles.nick}>{userNickname}</span>
                      </div>
                      <button
                        type='button'
                        className={styles.logout}
                        onClick={handleLogin}>
                        로그아웃
                      </button>
                    </>
                  ) : (
                    <button
                      type='button'
                      className={styles.login}
                      onClick={handleLogin}>
                      로그인
                    </button>
                  )}
                </div>
              </div>
            </header>

            <div id='conts'>
              <section className={styles.visual_area}>
                <div className={styles.inn}>
                  <div className={`${styles.tit_wrap} ${styles.blind}`}>
                    Welcome! 구독 아일랜드 06/16 ~ 07/18
                  </div>
                  <i className={styles.obj_tit1}></i>
                  <i className={styles.obj_tit2}></i>
                  <i className={styles.obj_tit3}></i>
                  <i className={styles.obj_tit4}></i>
                  <p className={styles.info_txt}>
                    <span className={styles.txt01}>
                      신규 / 복귀 스트리머 10분
                    </span>
                    에게 매주 추첨을 통해
                    <br />
                    <em className={styles.txt03}>10장씩</em> (총 100장){' '}
                    <em className={styles.txt03}>구독 선물권</em>을 드립니다.
                  </p>
                  <i className={styles.obj1}></i>
                  <i className={styles.obj2}></i>
                  <i className={styles.obj3}></i>
                </div>
              </section>

              <section className={styles.content_area}>
                <div className={styles.inn}>
                  <div className={styles.info_area}>
                    <p className={styles.info_area_txt}>
                      화면을 아래로 내려 <em>내용</em>을
                      <em className={styles.info_area_txt01}> 확인</em>하고
                      <br />
                      <span className={styles.info_area_txt02}>
                        구독 선물권 응모 기회
                      </span>
                      를 얻어보세요.
                    </p>
                  </div>

                  <ul className={styles.info_list}>
                    <li
                      data-aos='zoom-in'
                      className={`${styles.aos_init} ${styles.list_item}`}>
                      <strong className={styles.list_txt01}>
                        <em className={styles.list_txt01_1}>구독</em>이란?
                      </strong>
                      <p className={styles.list_txt02}>
                        매월 스트리머를 후원하는 서비스로
                        <br />
                        <em className={styles.list_txt02_1}>
                          후원 받은 구독을 실제 수익
                        </em>
                        으로
                        <br />
                        돌려 받을 수 있어요.
                      </p>
                    </li>
                    <li
                      data-aos='zoom-in'
                      className={`${styles.aos_init} ${styles.list_item}`}>
                      <strong className={styles.list_txt01}>
                        <em className={styles.list_txt01_1}>구독</em>종류는?
                      </strong>
                      <p className={styles.list_txt02}>
                        구독은 베이직과 플러스가 있어요.
                        <br />
                        <em className={styles.list_txt02_1}>베이직</em>은
                        <span className={styles.list_txt02_2}>
                          {' '}
                          일정한 가격
                        </span>
                        과
                        <span className={styles.list_txt02_2}>
                          {' '}
                          기본적인 혜택
                        </span>
                        이<br />
                        적용 돼요.
                        <br />
                        <em className={styles.list_txt02_1}>플러스</em>는{' '}
                        <span className={styles.list_txt02_2}>직접 가격</span>과{' '}
                        <span className={styles.list_txt02_2}>
                          혜택을 설정{' '}
                        </span>
                        할 수 있어요.
                      </p>
                    </li>
                    <li
                      data-aos='zoom-in'
                      className={`${styles.aos_init} ${styles.list_item}`}>
                      <strong className={styles.list_txt01}>
                        <em className={styles.list_txt01_1}>구독</em>혜택에는
                        뭐가 있지?
                      </strong>
                      <p className={styles.list_txt02}>
                        <em className={styles.list_txt02_1}>기본</em>적으로
                        <span className={styles.list_txt02_2}>
                          {' '}
                          전용 퍼스나콘 / 이모티콘 / 닉네임
                        </span>
                        <br />
                        설정이 가능하고
                        <br />
                        <em className={styles.list_txt02_1}>플러스</em>는
                        <span className={styles.list_txt02_2}>
                          {' '}
                          구독 전용LIVE / 구독팬 전용
                          <br />
                          다시보기 / TTS 무료 사용
                        </span>
                        이 가능해요.
                      </p>
                    </li>
                  </ul>
                  <button
                    className={styles.link_apply}
                    onClick={checkEventUser}>
                    구독 선물권 응모하기
                  </button>
                  <a
                    href={`${globalDomains.BJGUIDE_AFREECATV}/?page=SUBSCRIBE`}
                    target='_blank'
                    className={styles.link_info}>
                    <span className={styles.link_info_txt}>
                      구독에 대해 더 알아보고 싶다면?
                    </span>
                  </a>
                </div>
              </section>

              <section className={styles.notice_area}>
                <div className={styles.inn}>
                  <h3 className={styles.notice_tit}>
                    <span>이벤트</span> 유의사항
                  </h3>
                  <ul className={styles.notice_list}>
                    <li className={styles.notice_list_txt}>
                      해당 이벤트는 숲트리머 어드벤처에 참여하신 스트리머분들을
                      위한 보너스 이벤트입니다.
                    </li>
                    <li className={styles.notice_list_txt}>
                      매주 10명을 랜덤 추첨 하여, 10장의 구독 선물권을 드립니다.
                    </li>
                    <li className={styles.notice_list_txt}>
                      추첨은 매주 월요일에 진행이 되며, 당첨자는 개별 쪽지와
                      함께 구독 선물권이 지급 됩니다.
                    </li>
                    <li className={styles.notice_list_txt}>
                      대상 스트리머 선정 후 지급까지 최소 2영업일이 소요될 수
                      있습니다.
                    </li>
                    <li className={styles.notice_list_txt}>
                      이벤트로 지급 받은 구독 선물권의 유효기간은 1년입니다.
                    </li>
                    <li className={styles.notice_list_txt}>
                      본 이벤트는 7월 18일(금)까지 진행이 됩니다.
                    </li>
                    <li className={styles.notice_list_txt}>
                      중복 참여는 불가능 합니다.
                    </li>
                    <li className={styles.notice_list_txt}>
                      부정한 방법으로 이벤트에 참가할 경우 예고 없이 선물권이
                      회수 될 수 있습니다.
                    </li>
                  </ul>
                </div>
              </section>
            </div>

            <footer className={styles.footer}>ⓒ SOOP Corp.</footer>
          </div>
        </div>
        <div
          className={`${styles.layer_modal_wrap} ${isModalOpen ? styles.active : ''}`}>
          <div className={styles.flex_box}>
            <div className={styles.modal_contents}>
              <div className={`${styles.alert_layer} ${styles.on}`}>
                <div className={styles.contents}>
                  <p>{modalText}</p>
                </div>
                <div className={styles.btn_box}>
                  <button type='button' onClick={handleCloseModal}>
                    확인
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  );
};

export default GiftSubEvent;
